import { User, Calendar, Flag, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { COUNTRY_OPTIONS } from "../../constants/countries";

interface PersonalInformationCardProps {
  profile: any;
}

export function PersonalInformationCard({
  profile
}: PersonalInformationCardProps) {
  const { t } = useTranslation(["talent", "common"]);

  const formatDateOfBirth = (dateString: string) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("de-DE");
    const age = Math.floor(
      (Date.now() - date.getTime()) / (365.25 * 24 * 60 * 60 * 1000)
    );
    return `${formattedDate} (${age})`;
  };

  const getNationalityLabel = (nationalityCode: string) => {
    if (!nationalityCode) return null;
    const country = COUNTRY_OPTIONS.find((c) => c.value === nationalityCode);
    return country ? country.label : nationalityCode;
  };

  const formatRelationshipStatus = (status: string) => {
    if (!status) return null;
    return t(`forms.common.relationship_status.${status}`);
  };

  return (
    <div className="bg-white border rounded-lg p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <User className="h-5 w-5 text-gray-600" />
        <h3 className="font-semibold text-gray-900">Personal Information</h3>
      </div>
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <User className="h-4 w-4 text-gray-600 flex-shrink-0" />
          <span className="text-sm text-gray-600">
            {profile.given_name && profile.family_name
              ? `${profile.given_name} ${profile.family_name}`
              : profile.given_name || profile.family_name || "Unknown"}
          </span>
        </div>

        {profile.date_of_birth && (
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">
              {formatDateOfBirth(profile.date_of_birth)}
            </span>
          </div>
        )}

        {profile.nationality && (
          <div className="flex items-center gap-2">
            <Flag className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">
              {getNationalityLabel(profile.nationality)}
            </span>
          </div>
        )}

        {profile.relationship_status && (
          <div className="flex items-center gap-2">
            <Heart className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">
              {formatRelationshipStatus(profile.relationship_status)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
